var cov_1q5zrb483q = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Rule/type.ts",
      hash = "f74e60afe267460336bdd76b197c388b20861158",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Rule/type.ts",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 27
        },
        end: {
          line: 10,
          column: 1
        }
      },
      "1": {
        start: {
          line: 8,
          column: 15
        },
        end: {
          line: 8,
          column: 55
        }
      },
      "2": {
        start: {
          line: 9,
          column: 2
        },
        end: {
          line: 9,
          column: 43
        }
      },
      "3": {
        start: {
          line: 12,
          column: 16
        },
        end: {
          line: 12,
          column: 39
        }
      },
      "4": {
        start: {
          line: 14,
          column: 97
        },
        end: {
          line: 22,
          column: 3
        }
      },
      "5": {
        start: {
          line: 15,
          column: 2
        },
        end: {
          line: 22,
          column: 3
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 7,
            column: 27
          },
          end: {
            line: 7,
            column: 28
          }
        },
        loc: {
          start: {
            line: 7,
            column: 50
          },
          end: {
            line: 10,
            column: 1
          }
        },
        line: 7
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 14,
            column: 15
          },
          end: {
            line: 14,
            column: 16
          }
        },
        loc: {
          start: {
            line: 14,
            column: 97
          },
          end: {
            line: 22,
            column: 3
          }
        },
        line: 14
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 14,
            column: 97
          },
          end: {
            line: 14,
            column: 98
          }
        },
        loc: {
          start: {
            line: 15,
            column: 2
          },
          end: {
            line: 22,
            column: 3
          }
        },
        line: 15
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 8,
            column: 15
          },
          end: {
            line: 8,
            column: 55
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 8,
            column: 29
          },
          end: {
            line: 8,
            column: 41
          }
        }, {
          start: {
            line: 8,
            column: 44
          },
          end: {
            line: 8,
            column: 55
          }
        }],
        line: 8
      },
      "1": {
        loc: {
          start: {
            line: 14,
            column: 30
          },
          end: {
            line: 14,
            column: 92
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 14,
            column: 90
          },
          end: {
            line: 14,
            column: 92
          }
        }],
        line: 14
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0],
      "1": [0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import { deepMerge } from '../utils/objects';
import { substitute } from '../utils/strings';
import { getLocale } from '../locale';
cov_1q5zrb483q.s[0]++;
export var typeMessage = function typeMessage(props) {
  cov_1q5zrb483q.f[0]++;
  var path = (cov_1q5zrb483q.s[1]++, props.title ? (cov_1q5zrb483q.b[0][0]++, 'rules.type') : (cov_1q5zrb483q.b[0][1]++, 'rules.reg'));
  cov_1q5zrb483q.s[2]++;
  return substitute(getLocale(path), props);
};
var options = (cov_1q5zrb483q.s[3]++, {
  skipUndefined: true
});
export default (function (type) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_1q5zrb483q.b[1][0]++, {}),
      message = _ref.message,
      tip = _ref.tip;

  cov_1q5zrb483q.f[1]++;
  cov_1q5zrb483q.s[4]++;
  return function (msg) {
    cov_1q5zrb483q.f[2]++;
    cov_1q5zrb483q.s[5]++;
    return deepMerge({
      type: type,
      message: typeMessage
    }, deepMerge({
      message: message,
      tip: tip
    }, {
      message: msg
    }, options), options);
  };
});